import { useQuery } from "@tanstack/react-query";
import EnterpriseApiRoutes from "common/ApiRoutes";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
import { onError } from "util/conditional/onError";
export const ACTIVE_LICENSE_QUERY_KEY = "active_license";
const getLicense = () => fetch("GET", qualifyUrl(EnterpriseApiRoutes.License.active().url));
const useActiveLicenseInformation = () => {
  const { data, isFetching, isLoading, isError, refetch } = useQuery({
    queryKey: [ACTIVE_LICENSE_QUERY_KEY],
    queryFn: () => onError(getLicense(), (errorThrown) => {
      if (!(errorThrown.status === 404)) {
        UserNotification.error(`Loading active license information failed with: ${errorThrown}`);
      }
    }),
    retry: false,
    retryOnMount: false,
    staleTime: 3e4
  });
  return {
    data,
    isFetching,
    isLoading,
    isError,
    refetch
  };
};
export default useActiveLicenseInformation;
